import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {CreateResponsiveStyle} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle({
    container: {
      borderRadius: 16,
      position: 'absolute',
      bottom: 52,
      overflow: 'hidden',
      flexDirection: 'row',
      width: 274,
    },
    leftText: {
      ...props.typography.interMedium,
      fontSize: 14,
      color: props.colors.white,
      backgroundColor: props.colors.purple(1),
      paddingVertical: 8,
      paddingHorizontal: 12,
    },
    rightText: {
      ...props.typography.interMedium,
      fontSize: 14,
      color: props.colors.white,
      backgroundColor: props.colors.red,
      paddingVertical: 8,
      paddingHorizontal: 12,
    },
  })();
